import { PDFDocument } from "pdf-lib";

class PDFServices {
  async mergePages(pagesToMerge, originalPDF) {
    const existingPdfBytes = await fetch(originalPDF).then(res =>
      res.arrayBuffer()
    );
    const content = await PDFDocument.load(existingPdfBytes);
    const doc = await PDFDocument.create();
    const copiedPages = await doc.copyPages(content, pagesToMerge);

    for (const page of copiedPages) {
      doc.addPage(page);
    }

    return await doc.saveAsBase64({ dataUri: true }).then(resp => {
      return resp;
    });
  }
}

export default new PDFServices();
